import { render, staticRenderFns } from "./FriendTag.vue?vue&type=template&id=18749932&scoped=true"
import script from "./FriendTag.vue?vue&type=script&lang=js"
export * from "./FriendTag.vue?vue&type=script&lang=js"
import style0 from "./FriendTag.vue?vue&type=style&index=0&id=18749932&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18749932",
  null
  
)

export default component.exports